import { Table } from 'antd';
import { useSelector } from 'react-redux';
import { getTableColumns } from './constants';

export const MatchingPropertiesTable = () => {
  const { selectedOrganizationData, isLoading } = useSelector(
    ({ BuyersReportReducer }) => BuyersReportReducer,
  );

  return (
    <Table
      rowKey="_id"
      loading={isLoading}
      columns={getTableColumns()}
      dataSource={selectedOrganizationData?.matchingProperties || []}
    />
  );
};
